import React from "react";
import './stepCompetencesEvaluationDesc.css';
import { Typography, Descriptions, Card, Row, Col } from "antd";

const { Title } = Typography;

const StepCompetencesEvaluationDesc = ({
    evr_evaluator,
    evr_evaluator_fullname,
    evr_evaluator_job_title,
    evr_evaluated,
    evr_evaluated_fullname,
    evr_evaluated_job_title,
    evr_type,
    evr_srv_id
}) => {
    const sharedStyle = {
        fontSize: 13,
        textAlign: "left",
        paddingLeft: 8,
    };
    const sharedStyleLabel = {
        width: 120,
        fontSize: 13,
        textAlign: "left",
        paddingLeft: 8,
    };
    return (
        <div className="evaluation-desc-card">
            <Title level={4} className="evaluation-desc-title">
                Datos de la evaluación
            </Title>

            <Row gutter={16}>
                <Col xs={24} sm={evr_srv_id != 3 ? 12 : 24}>
                    <Descriptions
                        className="evaluation-desc-table"
                        bordered
                        size="small"
                        column={1}
                        style={{ marginBottom: 8 }}
                        labelStyle={sharedStyleLabel}
                        contentStyle={sharedStyle}
                    >
                        <Descriptions.Item style={{ fontSize: '16px' }} label="Evaluador">{evr_evaluator}</Descriptions.Item>
                        <Descriptions.Item style={{ fontSize: '16px' }} label="Nombre">{evr_evaluator_fullname}</Descriptions.Item>
                        <Descriptions.Item style={{ fontSize: '16px' }} label="Cargo">{evr_evaluator_job_title}</Descriptions.Item>
                    </Descriptions>
                </Col>

                {
                    evr_srv_id != 3 && <Col xs={24} sm={evr_srv_id != 3 ? 12 : 24}>
                        <Descriptions
                            className="evaluation-desc-table"
                            bordered
                            size="small"
                            column={1}
                            style={{ marginBottom: 8 }}
                            labelStyle={sharedStyleLabel}
                            contentStyle={sharedStyle}
                        >
                            <Descriptions.Item style={{ fontSize: '16px' }} label="Evaluado">{evr_evaluated}</Descriptions.Item>
                            <Descriptions.Item style={{ fontSize: '16px' }} label="Nombre">{evr_evaluated_fullname}</Descriptions.Item>
                            <Descriptions.Item style={{ fontSize: '16px' }} label="Cargo">{evr_evaluated_job_title}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                }
            </Row>

            {
                evr_srv_id != 3 && <Descriptions
                    className="evaluation-desc-table"
                    bordered
                    size="small"
                    column={1}
                    labelStyle={sharedStyleLabel}
                    contentStyle={sharedStyle}
                >
                    <Descriptions.Item style={{ fontSize: '16px' }} label="Relación">{evr_type}</Descriptions.Item>
                </Descriptions>
            }
            
        </div>
    );
};

export default StepCompetencesEvaluationDesc;
